import { useState } from "react";
import Outright from "./Outright";
import Flexible from "./Flexible";
import State from "./State";

const UserCategoryTable = () => {
  const [activeTab, setActiveTab] = useState("outright");

  const switchTabs = (tab: string) => {
    setActiveTab(tab);
  };

  return (
    <section>
      <div className="flex gap-10 mb-6">
        <span
          className={`cursor-pointer pb-2 ${activeTab === "outright" ? "border-b-2 border-green-500" : "null"
            }`}
          onClick={() => switchTabs("outright")}
        >
          Outright
        </span>
        <span
          className={`cursor-pointer pb-2 ${activeTab === "flexible" ? "border-b-2 border-green-500" : "null"
            }`}
          onClick={() => switchTabs("flexible")}
        >
          Flexible
        </span>
        <span
          className={`cursor-pointer pb-2 ${activeTab === "state" ? "border-b-2 border-green-500" : "null"
            }`}
          onClick={() => switchTabs("state")}
        >
          State
        </span>
        <span
          className={`cursor-pointer pb-2 ${activeTab === "microfinance"
              ? "border-b-2 border-green-500"
              : "null"
            }`}
          onClick={() => switchTabs("microfinance")}
        >
          Micro Finance
        </span>
        <span
          className={`cursor-pointer pb-2 ${activeTab === "church" ? "border-b-2 border-green-500" : "null"
            }`}
          onClick={() => switchTabs("church")}
        >
          Church
        </span>
        <span
          className={`cursor-pointer pb-2 ${activeTab === "privateOrg" ? "border-b-2 border-green-500" : "null"
            }`}
          onClick={() => switchTabs("privateOrg")}
        >
          Private Organization
        </span>
      </div>
      <section>
        {activeTab === "outright" && <Outright activeTab={activeTab} />}
        {activeTab === "flexible" && <Flexible activeTab={activeTab} />}
        {activeTab === "state" && <State activeTab={activeTab} />}
        {/* {activeTab === "microfinance" && <MicroFinance />}
        {activeTab === "church" && <Church />}
        {activeTab === "privateOrg" && <PrivateOrg />} */}
      </section>
    </section>
  );
};

export default UserCategoryTable;
